/**
 * SK Features — Tab, carousel and hero interactions.
 * Loaded once, handles both initial render and customizer re-renders.
 */
(function () {
  function unloadIframes(scope) {
    scope.querySelectorAll('.sk-pf-media__iframe-wrap iframe').forEach(function (f) {
      var src = f.getAttribute('src');
      if (src) { f.dataset.skSrc = src; f.removeAttribute('src'); }
    });
  }

  function reloadIframes(scope) {
    scope.querySelectorAll('.sk-pf-media__iframe-wrap iframe').forEach(function (f) {
      if (!f.getAttribute('src') && f.dataset.skSrc) f.setAttribute('src', f.dataset.skSrc);
    });
  }

  function initFeatures(root) {
    root = root || document;

    root.querySelectorAll('.sk-pf-media__vid-wrap').forEach(function (wrap) {
      if (wrap._skPlayInit) return;
      wrap._skPlayInit = true;
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-sk-mute-toggle]')) return;
        var vid = wrap.querySelector('video');
        if (!vid) return;
        if (vid.paused) {
          vid.play().catch(function () {});
          wrap.classList.add('is-playing');
        } else {
          vid.pause();
          wrap.classList.remove('is-playing');
        }
      });
      var vid = wrap.querySelector('video');
      if (vid) {
        vid.addEventListener('ended', function () {
          wrap.classList.remove('is-playing');
        });
        vid.addEventListener('play', function () {
          wrap.classList.add('is-playing');
          // Only one card video at a time: pause the others when this starts
          if (wrap.closest('.sk-features__card-image')) {
            document.querySelectorAll('.sk-features__card-image video').forEach(function (other) {
              if (other !== vid && !other.paused) other.pause();
            });
          }
        });
        vid.addEventListener('pause', function () {
          if (!vid.ended) wrap.classList.remove('is-playing');
        });
      }
    });

    root.querySelectorAll('[data-sk-features]').forEach(function (w) {
      if (w._skInit) return;
      w._skInit = true;
      var tabMuted = false;
      var tabVisible = true;
      var autoplay = w.dataset.skAutoplay !== 'false';

      function pauseAllVideos() {
        w.querySelectorAll('video').forEach(function (v) {
          v.pause();
        });
        unloadIframes(w);
      }

      function resumeActiveVideo() {
        var activeImg = w.querySelector('.sk-features__image.is-active');
        if (activeImg) reloadIframes(activeImg);
        if (!autoplay) return;
        var active = activeImg ? activeImg.querySelector('video') : null;
        if (active && active.paused && !active.ended) {
          active.muted = tabMuted;
          active.play().catch(function () {});
        }
      }

      var tabWraps = w.querySelectorAll('[data-sk-features-tab-wrap]');
      tabWraps.forEach(function (wrap) {
        wrap.addEventListener('click', function () {
          var tab = wrap.querySelector('[data-sk-features-tab]');
          if (!tab) return;
          var idx = tab.dataset.skFeaturesTab;
          pauseAllVideos();
          tabWraps.forEach(function (tw) { tw.classList.remove('is-active'); });
          w.querySelectorAll('.sk-features__image.is-active').forEach(function (el) { el.classList.remove('is-active'); });
          wrap.classList.add('is-active');
          var img = w.querySelector('[data-sk-features-image="' + idx + '"]');
          if (img) {
            img.classList.add('is-active');
            var vid = img.querySelector('video');
            if (vid) {
              vid.currentTime = 0;
              if (autoplay && tabVisible) {
                vid.muted = tabMuted;
                if (tabMuted) { vid.setAttribute('muted', ''); } else { vid.removeAttribute('muted'); }
                vid.play().catch(function () {});
              }
            } else {
              reloadIframes(img);
            }
          }
        });
      });

      var muteBtn = w.querySelector('[data-sk-mute-toggle]');
      if (muteBtn && !muteBtn._skMuteInit) {
        muteBtn._skMuteInit = true;
        var mediaWrap = w.querySelector('[data-sk-media-wrap]');
        if (mediaWrap) mediaWrap.dataset.skMuted = 'false';
        muteBtn.addEventListener('click', function () {
          tabMuted = !tabMuted;
          if (mediaWrap) mediaWrap.dataset.skMuted = tabMuted ? 'true' : 'false';
          w.querySelectorAll('video').forEach(function (v) {
            v.muted = tabMuted;
            if (tabMuted) { v.setAttribute('muted', ''); } else { v.removeAttribute('muted'); }
          });
        });
      }

      var section = w.closest('.shopify-section') || w;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tabVisible = true;
            resumeActiveVideo();
          } else {
            tabVisible = false;
            pauseAllVideos();
          }
        });
      }, { threshold: 0 }).observe(section);
    });

    root.querySelectorAll('[data-sk-features-hero]').forEach(function (hero) {
      if (hero._skHeroInit) return;
      hero._skHeroInit = true;
      var slider = hero.querySelector('sk-slider');
      if (!slider) return;
      var track = slider.querySelector('[data-sk-track]');
      if (!track) return;

      var imgs = hero.querySelectorAll('[data-hero-idx]');
      var cards = hero.querySelectorAll('[data-hero-slide]');
      var activeIdx = 0;
      var isMuted = false;
      var heroVisible = true;
      var heroAutoplay = hero.dataset.skAutoplay !== 'false';
      var clickScrolling = false;
      var clickTimer = null;

      var mediaWrap = hero.querySelector('[data-sk-media-wrap]');
      if (mediaWrap) mediaWrap.dataset.skMuted = 'false';

      function getCenterSlideIndex() {
        var slides = track.children;
        if (!slides.length) return 0;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var card = slides[i].querySelector('[data-hero-slide]');
          if (!card) continue;
          var mid = slides[i].offsetLeft + slides[i].offsetWidth / 2;
          var dist = Math.abs(mid - center);
          if (dist < bestDist) { bestDist = dist; best = parseInt(card.dataset.heroSlide); }
        }
        return best;
      }

      function resumeHeroVideo() {
        var target = hero.querySelector('[data-hero-idx="' + activeIdx + '"]');
        if (target) reloadIframes(target);
        if (!heroAutoplay) return;
        var vid = target ? target.querySelector('video') : null;
        if (vid && vid.paused && !vid.ended) {
          vid.muted = isMuted;
          vid.play().catch(function () {});
        }
      }

      function setActive(idx) {
        if (idx === activeIdx) return;
        hero.querySelectorAll('video').forEach(function (v) { v.pause(); });
        unloadIframes(hero);
        imgs.forEach(function (img) { img.classList.remove('is-active'); });
        cards.forEach(function (c) { c.classList.remove('is-active'); });
        var target = hero.querySelector('[data-hero-idx="' + idx + '"]');
        var card = hero.querySelector('[data-hero-slide="' + idx + '"]');
        if (target) target.classList.add('is-active');
        if (card) card.classList.add('is-active');
        activeIdx = idx;

        var vid = target ? target.querySelector('video') : null;
        if (vid) {
          vid.currentTime = 0;
          if (heroAutoplay && heroVisible) {
            vid.muted = isMuted;
            if (isMuted) { vid.setAttribute('muted', ''); } else { vid.removeAttribute('muted'); }
            vid.play().catch(function () {});
          }
        } else if (target) {
          reloadIframes(target);
        }
      }

      track.addEventListener('scroll', function () {
        if (clickScrolling) return;
        if (hero._heroRaf) cancelAnimationFrame(hero._heroRaf);
        hero._heroRaf = requestAnimationFrame(function () {
          setActive(getCenterSlideIndex());
        });
      }, { passive: true });

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var idx = parseInt(this.dataset.heroSlide, 10);
          if (idx === activeIdx) return;
          clickScrolling = true;
          if (clickTimer) clearTimeout(clickTimer);
          clickTimer = setTimeout(function () { clickScrolling = false; }, 600);
          var slides = track.children;
          for (var i = 0; i < slides.length; i++) {
            var c = slides[i].querySelector('[data-hero-slide]');
            if (c && parseInt(c.dataset.heroSlide, 10) === idx) {
              var slideCenter = slides[i].offsetLeft + slides[i].offsetWidth / 2;
              track.scrollTo({ left: slideCenter - track.clientWidth / 2, behavior: 'smooth' });
              break;
            }
          }
          setActive(idx);
        });
      });

      var muteBtn = hero.querySelector('[data-sk-mute-toggle]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          isMuted = !isMuted;
          if (mediaWrap) mediaWrap.dataset.skMuted = isMuted ? 'true' : 'false';
          hero.querySelectorAll('video').forEach(function (v) {
            v.muted = isMuted;
            if (isMuted) { v.setAttribute('muted', ''); } else { v.removeAttribute('muted'); }
          });
        });
      }

      var heroSection = hero.closest('.shopify-section') || hero;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            heroVisible = true;
            resumeHeroVideo();
          } else {
            heroVisible = false;
            hero.querySelectorAll('video').forEach(function (v) { v.pause(); });
            unloadIframes(hero);
          }
        });
      }, { threshold: 0 }).observe(heroSection);
    });

    // Carousel / grid cards: stop media when the card leaves the visible
    // area (carousel slide change clips via the track's overflow, page
    // scroll moves the section off-screen — both read as non-intersecting).
    var cardMedias = root.querySelectorAll('.sk-features__card-image');
    if (cardMedias.length && 'IntersectionObserver' in window) {
      var cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var vid = card.querySelector('video');
          if (entry.isIntersecting) {
            if (vid && vid.hasAttribute('autoplay') && card._skWasPlaying && vid.paused && !vid.ended) {
              vid.play().catch(function () {});
            }
            reloadIframes(card);
          } else {
            if (vid) {
              card._skWasPlaying = !vid.paused;
              vid.pause();
            }
            unloadIframes(card);
          }
        });
      }, { threshold: 0 });
      cardMedias.forEach(function (card) {
        if (card._skVisInit) return;
        card._skVisInit = true;
        if (!card.querySelector('video') && !card.querySelector('.sk-pf-media__iframe-wrap iframe')) return;
        cardObserver.observe(card);
      });
    }

  }

  initFeatures();

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-sk-features]').forEach(function (w) { w._skInit = false; });
      e.target.querySelectorAll('[data-sk-features-hero]').forEach(function (h) { h._skHeroInit = false; });
      initFeatures(e.target);
    });
  }
})();
